<template>
    <div class="container-fluid container-bg-image" :style="`background-image: url(${background})`">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-10 offset-lg-1">
                    <p class="container-bg-title">{{value.title}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-5 offset-lg-1">
                    <p 
                        class="container-bg-text" 
                        v-for="text in value.column_one" 
                        :key="text.id" 
                        v-html="text.value">
                    </p>
                </div>
                <div class="col-12 col-lg-5">
                    <p 
                        class="container-bg-text" 
                        v-for="text in value.column_two" 
                        :key="text.id" 
                        v-html="text.value">
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
export default {
    name:'TwoColumn',
    props:['value'],
    data() {
        return {
            background:null
        }
    },
    mounted() {
        this.background = utils.image(this.value.image, 1440,808)
    }
}
</script>